module.exports = __webpack_public_path__ + "static/17-thumb-0c6f9673d7279aea2beab28362f1ecf9.jpg";